import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 200,
        position: "relative",
    },
    dotsContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(1.5),
        zIndex: 2,
    },
    dot: {
        width: 12,
        height: 12,
        borderRadius: "50%",
        background: "linear-gradient(180deg, #60a5fa, #7c3aed)",
        animation: "$bounce 1.4s infinite ease-in-out both",
    },
    "@keyframes bounce": {
        "0%, 80%, 100%": { transform: "scale(0)" },
        "40%": { transform: "scale(1.2)" },
    },
    "@keyframes pulse": {
        "0%, 100%": { transform: "scale(1)" },
        "50%": { transform: "scale(1.3)" },
    },
    thinkingText: {
        marginTop: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontWeight: 500,
        letterSpacing: 0.5,
        animation: "$fade 2s ease-in-out infinite",
    },
    "@keyframes fade": {
        "0%, 100%": { opacity: 0.6 },
        "50%": { opacity: 1 },
    },
}));

export default function AILoader() {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Box className={classes.dotsContainer}>
                <div className={classes.dot} style={{ animationDelay: "0s" }} />
                <div className={classes.dot} style={{ animationDelay: "0.2s" }} />
                <div className={classes.dot} style={{ animationDelay: "0.4s" }} />
            </Box>
            <Typography variant="body2" className={classes.thinkingText}>
                Thinking...
            </Typography>
        </Box>
    );
}
